import { Routes } from '@angular/router';
import { authGuard, superAdminGuard } from './guards/auth.guard';

export const routes: Routes = [
  {
    path: 'sign/:token',
    loadComponent: () => import('./components/public/signing-page/signing-page').then(m => m.SigningPage)
  },
  {
    path: '',
    redirectTo: 'manage/tenants',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadComponent: () => import('./components/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'platform-admin/approvals',
    loadComponent: () => import('./components/manage/approvals/approvals.component').then(m => m.ApprovalsComponent),
    canActivate: [superAdminGuard]
  },
  {
    path: 'unauthorized',
    loadComponent: () => import('./components/unauthorized/unauthorized.component').then(m => m.UnauthorizedComponent)
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./components/dashboard/tenant-dashboard/tenant-dashboard').then(m => m.TenantDashboard),
    canActivate: [superAdminGuard]
  },
  {
    path: 'wizard',
    loadComponent: () => import('./components/wizard/tenant-onboarding-wizard/tenant-onboarding-wizard').then(m => m.TenantOnboardingWizard),
    canActivate: [superAdminGuard],
    children: [
      {
        path: '',
        redirectTo: 'identity',
        pathMatch: 'full'
      },
      {
        path: 'identity',
        loadComponent: () => import('./components/wizard/steps/step-identity/step-identity').then(m => m.StepIdentity)
      },
      {
        path: 'basic-info',
        loadComponent: () => import('./components/wizard/steps/step-basic-info/step-basic-info').then(m => m.StepBasicInfo)
      },
      {
        path: 'configuration',
        loadComponent: () => import('./components/wizard/steps/step-configuration/step-configuration').then(m => m.StepConfiguration)
      },
      {
        path: 'subscription',
        loadComponent: () => import('./components/wizard/steps/step-subscription/step-subscription').then(m => m.StepSubscription)
      },
      {
        path: 'localization',
        loadComponent: () => import('./components/wizard/steps/step-localization/step-localization').then(m => m.StepLocalization)
      },
      {
        path: 'infrastructure',
        loadComponent: () => import('./components/wizard/steps/step-infrastructure/step-infrastructure').then(m => m.StepInfrastructure)
      },
      {
        path: 'system-configuration',
        loadComponent: () => import('./components/wizard/steps/step-system-configuration/step-system-configuration').then(m => m.StepSystemConfiguration)
      },
      {
        path: 'legal-information',
        loadComponent: () => import('./components/wizard/steps/step-legal-information/step-legal-information').then(m => m.StepLegalInformation)
      },
      {
        path: 'review',
        loadComponent: () => import('./components/wizard/steps/step-review/step-review').then(m => m.StepReview)
      },
      {
        path: 'submit',
        loadComponent: () => import('./components/wizard/steps/step-submit/step-submit').then(m => m.StepSubmit)
      },
      {
        path: 'success',
        loadComponent: () => import('./components/wizard/steps/step-success/step-success').then(m => m.StepSuccess)
      }
    ]
  },
  {
    path: 'manage/supplier',
    loadComponent: () => import('./components/manage/suppliers/suppliers.component').then(m => m.SuppliersComponent),
    canActivate: [superAdminGuard]
  },
  {
    path: 'manage/tenant-suppliers',
    loadComponent: () => import('./components/manage/tenant-suppliers/tenant-suppliers.component').then(m => m.TenantSuppliersComponent),
    canActivate: [authGuard]
  },
  {
    path: 'manage/business-plan',
    loadComponent: () => import('./components/manage/business-plans/business-plans.component').then(m => m.BusinessPlansComponent),
    canActivate: [superAdminGuard]
  },
  {
    path: 'manage/account-status',
    loadComponent: () => import('./components/manage/account-statuses/account-statuses.component').then(m => m.AccountStatusesComponent),
    canActivate: [superAdminGuard]
  },
  {
    path: 'manage/smart-assist',
    loadComponent: () => import('./components/manage/smart-assist/smart-assist.component').then(m => m.SmartAssistComponent),
    canActivate: [superAdminGuard]
  },
  {
    path: 'manage/value-product-access',
    loadComponent: () => import('./components/manage/value-product-access/value-product-access.component').then(m => m.ValueProductAccessComponent),
    canActivate: [authGuard]
  },
  {
    path: 'manage/hosting-type',
    loadComponent: () => import('./components/manage/hosting-types/hosting-types.component').then(m => m.HostingTypesComponent),
    canActivate: [superAdminGuard]
  },
  {
    path: 'manage/environments',
    loadComponent: () => import('./components/manage/tenant-environments/tenant-environments.component').then(m => m.TenantEnvironmentsComponent),
    canActivate: [superAdminGuard]
  },
  {
    path: 'manage/sales-channels',
    loadComponent: () => import('./components/manage/sales-channels/sales-channels.component').then(m => m.SalesChannelsComponent),
    canActivate: [superAdminGuard]
  },
  {
    path: 'manage/value-products',
    loadComponent: () => import('./components/manage/value-products/value-products.component').then(m => m.ValueProductsComponent),
    canActivate: [superAdminGuard]
  },
  {
    path: 'manage/smartserve',
    loadComponent: () => import('./components/manage/smartserve/smartserve.component').then(m => m.SmartServeComponent),
    canActivate: [superAdminGuard]
  },
  {
    path: 'manage/smartreach',
    loadComponent: () => import('./components/manage/smartreach/smartreach.component').then(c => c.SmartReachComponent)
  },
  {
    path: 'manage/smartreach/dashboard',
    loadComponent: () => import('./components/manage/smartreach/smartreach-dashboard.component').then(c => c.SmartReachDashboardComponent)
  },
  {
    path: 'manage/smartreach/campaigns',
    loadComponent: () => import('./components/manage/smartreach/smartreach-campaigns.component').then(c => c.SmartReachCampaignsComponent)
  },
  {
    path: 'manage/smartengage',
    loadComponent: () => import('./components/manage/smartengage/smartengage.component').then(c => c.SmartEngageComponent)
  },
  {
    path: 'manage/smartengage/dashboard',
    loadComponent: () => import('./components/manage/smartengage/smartengage-dashboard.component').then(c => c.SmartEngageDashboardComponent)
  },
  {
    path: 'manage/smartengage/conversations',
    loadComponent: () => import('./components/manage/smartengage/smartengage-conversations.component').then(c => c.SmartEngageConversationsComponent)
  },
  // Administration - User Management
  {
    path: 'manage/users',
    loadComponent: () => import('./components/manage/users/users.component').then(m => m.UsersComponent),
    canActivate: [superAdminGuard]
  },
  // Administration - Role Management
  {
    path: 'manage/roles',
    loadComponent: () => import('./components/manage/roles/roles.component').then(m => m.RolesComponent),
    canActivate: [superAdminGuard]
  },
  // Administration - Permissions Management
  {
    path: 'manage/permissions',
    loadComponent: () => import('./components/manage/permissions/permissions.component').then(m => m.PermissionsComponent),
    canActivate: [superAdminGuard]
  },
  // Administration - Organizational Units Management
  {
    path: 'manage/organizational-units',
    loadComponent: () => import('./components/manage/organizational-units/organizational-units.component').then(m => m.OrganizationalUnitsComponent),
    canActivate: [superAdminGuard]
  },
  {
    path: 'manage/organizational-units/create',
    loadComponent: () => import('./components/manage/organizational-units/create-organizational-unit/create-organizational-unit.component').then(m => m.CreateOrganizationalUnitComponent),
    canActivate: [superAdminGuard]
  },
  {
    path: 'manage/organizational-units/edit/:id',
    loadComponent: () => import('./components/manage/organizational-units/create-organizational-unit/create-organizational-unit.component').then(m => m.CreateOrganizationalUnitComponent),
    canActivate: [superAdminGuard]
  },
  // Post-Onboarding - Organization Setup (Supplier Assignment, etc.)
  {
    path: 'organization-setup/:tenantId/:orgUnitId',
    loadComponent: () => import('./components/post-onboarding/organization-setup/organization-setup.component').then(m => m.OrganizationSetupComponent),
    canActivate: [superAdminGuard]
  },
  {
    path: 'manage/billing',
    loadComponent: () => import('./components/manage/billing/billing.component').then(m => m.BillingComponent),
    canActivate: [superAdminGuard]
  },
  {
    path: 'helpdesk',
    loadComponent: () => import('./components/helpdesk/helpdesk.component').then(m => m.HelpdeskComponent),
    canActivate: [superAdminGuard]
  },
  {
    path: 'reports',
    loadComponent: () => import('./components/reports/reports.component').then(m => m.ReportsComponent),
    canActivate: [superAdminGuard]
  },
  {
    path: 'manage/tenants',
    loadComponent: () => import('./components/manage/tenants/tenants-management.component').then(m => m.TenantsManagementComponent),
    canActivate: [superAdminGuard]
  },
  {
    path: 'manage/migration-management',
    loadComponent: () => import('./components/manage/migration-management/migration-management.component').then(m => m.MigrationManagementComponent),
    canActivate: [superAdminGuard]
  },
  {
    path: 'manage/tenants/:id',
    loadComponent: () => import('./components/manage/tenants/tenant-detail/tenant-detail.component').then(m => m.TenantDetailComponent),
    canActivate: [superAdminGuard]
  },
  {
    path: '**',
    redirectTo: 'manage/tenants'
  }
];
